/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { INamedConfigItem, INamedConfigResolver, TGenericBlueprintSchema } from "@adapptio/lib-blueprint";
import { IntegrationService } from "../IntegrationService";

/**
 * Integration Params Resolver
 */
export class IntegrationParamsResolver implements INamedConfigResolver {
	public constructor(private integrationSvc: IntegrationService) {}

	/**
	 * Returns options schema for a given integration type
	 *
	 * @param name
	 */
	getOptsSchemaByName(name: string): TGenericBlueprintSchema {
		return this.integrationSvc.getIntegrationType(name)?.optionsSchema || null;
	}

	/**
	 * Return list of integrationTypes
	 *
	 * @return INamedConfigItem[]
	 */
	getNameList(): INamedConfigItem[] {
		return this.integrationSvc.getIntegrationTypes().map((intgType) => ({
			name: intgType.integrationType,
			label: intgType.label,
			description: intgType.description,
			icon: intgType.icon
		}));
	}
}
